<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><g clip-path="url(#clip0)" fill="currentColor"><path d="M16.97 6.187H3.281A3.292 3.292 0 000 9.469v11.062a3.292 3.292 0 003.282 3.282H16.97a3.292 3.292 0 003.283-3.282V9.469a3.27 3.27 0 00-3.283-3.282zM27.57 7.992a1.672 1.672 0 00-.557.23l-5.12 2.954v7.615l5.153 2.954c.952.558 2.133.23 2.691-.722.164-.296.263-.624.263-.985V9.896c0-1.214-1.149-2.2-2.43-1.904z"/></g><defs><clipPath id="clip0"><path fill="currentColor" d="M0 0h30v30H0z"/></clipPath></defs></svg>
</template>

<script>
  export default {
    name: 'VideoIcon',
  }
</script>
